<div [class.standalone]="standalone" class="ui-tab narrower-input">
  <div>
    <h4 *ngIf="!standalone" class="page-title">{{ 'CAMERA_EDIT_MENU.CONFIGURATION' | translate }}</h4>

    <form [formGroup]="configurationForm">
      <div class="flex-col gap-16">
        <h5 class="section-title">{{ 'CAMERA_EDIT_CONFIGURATION.NETWORK_PROFILE' | translate }}</h5>
        <div class="profile-wrapper flex-row gap-8">
          <div (click)="selectProfile(NetworkProfile.HighQuality)" [class.selected]="isProfileSelected(NetworkProfile.HighQuality)"
               class="profile">
            {{ 'CAMERA_EDIT_CONFIGURATION.HIGH_QUALITY' | translate }}
          </div>
          <div (click)="selectProfile(NetworkProfile.LowBandwidth)" [class.selected]="isProfileSelected(NetworkProfile.LowBandwidth)"
               class="profile">
            {{ 'CAMERA_EDIT_CONFIGURATION.LOW_BANDWIDTH' | translate }}
          </div>
          <div (click)="selectProfile(NetworkProfile.Custom)" [class.selected]="isProfileSelected(NetworkProfile.Custom)"
               class="profile">
            {{ 'CAMERA_EDIT_CONFIGURATION.CUSTOM' | translate }}
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="configurationForm">
      <div class="flex-col gap-24">
        <div class="config-section">
          <h5 class="section-title">{{ 'CAMERA_EDIT_CONFIGURATION.ANALYTICS_STREAM_SOURCE' | translate }}</h5>
          <div class="flex-col start-start gap-10 max">
            <label>{{ 'CAMERA_EDIT_CONFIGURATION.STREAM_SOURCE' | translate }}</label>
            <mat-select class="ui-selector" formControlName="analyticsStreamSource">
              <mat-option [value]="StreamId.mainstream">{{ 'CAMERA_EDIT_CONFIGURATION.MAINSTREAM' | translate }}
              </mat-option>
              <mat-option [value]="StreamId.substream1">{{ 'CAMERA_EDIT_CONFIGURATION.SUBSTREAM' | translate }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <h5 class="section-title">{{ 'CAMERA_EDIT_CONFIGURATION.AUDIO_CONFIGURATION' | translate }}</h5>
        <div [formGroup]="audioConfigurationForm" class="config-section flex-col gap-8">
          <div class="flex-row start-start gap-10">
            <ui-toggle formControlName="mainStreamEnabled"></ui-toggle>
            <label>{{ 'CAMERA_EDIT_CONFIGURATION.AUDIO_MAINSTREAM_ENABLE' | translate }}</label>
          </div>
          <div class="flex-row start-start gap-10">
            <ui-toggle formControlName="subStreamEnabled"></ui-toggle>
            <label>{{ 'CAMERA_EDIT_CONFIGURATION.AUDIO_SUBSTREAM_ENABLE' | translate }}</label>
          </div>
        </div>

        <h5 class="section-title mt-8">{{ 'CAMERA_EDIT_CONFIGURATION.REMOTE_LIVE_VIEW_CONFIGURATION' | translate }}</h5>

        <div class="config-section" formGroupName="hqConfig">
          <h5 class="section-title">{{ 'CAMERA_EDIT_CONFIGURATION.HQ_CONFIGURATION' | translate }}</h5>
          <div class="flex-col gap-15">
            <div class="flex-row start-start gap-10">
              <ui-toggle formControlName="isOnlyWhenNeeded"></ui-toggle>
              <label>{{ 'CAMERA_EDIT_CONFIGURATION.ONLY_WHEN_NEEDED' | translate }}</label>
            </div>

            <div class="livekit-section" formGroupName="liveKit">
              <div class="flex-row start-start gap-10">
                <ui-toggle formControlName="isPassthrough"></ui-toggle>
                <label>{{ 'CAMERA_EDIT_CONFIGURATION.PASSTHROUGH' | translate }}</label>
              </div>

              <div class="form-grid">
                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.CODEC' | translate }}</label>
                  <mat-select class="ui-selector" formControlName="codec">
                    <mat-option *ngFor="let codec of codecTypes" [value]="codec">
                      {{ codec }}
                    </mat-option>
                  </mat-select>
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MAX_WIDTH' | translate }}</label>
                  <input class="ui-input" formControlName="maxWidth" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MAX_HEIGHT' | translate }}</label>
                  <input class="ui-input" formControlName="maxHeight" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.FPS' | translate }}</label>
                  <input class="ui-input" formControlName="fps" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.IFRAME_INTERVAL' | translate }}</label>
                  <input class="ui-input" formControlName="iFrameInterval" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MAX_BITRATE' | translate }}</label>
                  <input class="ui-input" formControlName="maxBitrate" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MIN_BITRATE' | translate }}</label>
                  <input class="ui-input" formControlName="minBitrate" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.START_BITRATE' | translate }}</label>
                  <input class="ui-input" formControlName="startBitrate" type="number" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="config-section" formGroupName="mqConfig">
          <h5 class="section-title">{{ 'CAMERA_EDIT_CONFIGURATION.MQ_CONFIGURATION' | translate }}</h5>
          <div class="flex-col gap-15">
            <div class="flex-row start-start gap-10">
              <ui-toggle formControlName="enable"></ui-toggle>
              <label>{{ 'CAMERA_EDIT_CONFIGURATION.ENABLED' | translate }}</label>
            </div>
            <div class="flex-row start-start gap-10" formGroupName="liveKit">
              <ui-toggle formControlName="isPassthrough"></ui-toggle>
              <label>{{ 'CAMERA_EDIT_CONFIGURATION.PASSTHROUGH' | translate }}</label>
            </div>
            <div class="flex-col start-start gap-10 max">
              <label>{{ 'CAMERA_EDIT_CONFIGURATION.STREAM_SOURCE' | translate }}</label>
              <mat-select class="ui-selector" formControlName="streamSource">
                <mat-option [value]="StreamId.mainstream">{{ 'CAMERA_EDIT_CONFIGURATION.MAINSTREAM' | translate }}
                </mat-option>
                <mat-option [value]="StreamId.substream1">{{ 'CAMERA_EDIT_CONFIGURATION.SUBSTREAM' | translate }}
                </mat-option>
              </mat-select>
            </div>
            <div class="livekit-section" formGroupName="liveKit">

              <div class="form-grid">
                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.CODEC' | translate }}</label>
                  <mat-select class="ui-selector" formControlName="codec">
                    <mat-option *ngFor="let codec of codecTypes" [value]="codec">
                      {{ codec }}
                    </mat-option>
                  </mat-select>
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MAX_WIDTH' | translate }}</label>
                  <input class="ui-input" formControlName="maxWidth" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MAX_HEIGHT' | translate }}</label>
                  <input class="ui-input" formControlName="maxHeight" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.FPS' | translate }}</label>
                  <input class="ui-input" formControlName="fps" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.IFRAME_INTERVAL' | translate }}</label>
                  <input class="ui-input" formControlName="iFrameInterval" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MAX_BITRATE' | translate }}</label>
                  <input class="ui-input" formControlName="maxBitrate" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MIN_BITRATE' | translate }}</label>
                  <input class="ui-input" formControlName="minBitrate" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.START_BITRATE' | translate }}</label>
                  <input class="ui-input" formControlName="startBitrate" type="number" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="config-section" formGroupName="sqConfig">
          <h5 class="section-title">{{ 'CAMERA_EDIT_CONFIGURATION.SQ_CONFIGURATION' | translate }}</h5>
          <div class="flex-col gap-15">
            <div class="flex-row start-start gap-10">
              <ui-toggle formControlName="enable"></ui-toggle>
              <label>{{ 'CAMERA_EDIT_CONFIGURATION.ENABLED' | translate }}</label>
            </div>

            <div class="livekit-section" formGroupName="liveKit">
              <div class="flex-row start-start gap-10">
                <ui-toggle formControlName="isPassthrough"></ui-toggle>
                <label>{{ 'CAMERA_EDIT_CONFIGURATION.PASSTHROUGH' | translate }}</label>
              </div>
              <div class="form-grid">
                <div class="flex-col start-start gap-10 w-100">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.CODEC' | translate }}</label>
                  <mat-select class="flex w-100 ui-selector" formControlName="codec">
                    <mat-option *ngFor="let codec of codecTypes" [value]="codec">
                      {{ codec }}
                    </mat-option>
                  </mat-select>
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MAX_WIDTH' | translate }}</label>
                  <input class="ui-input" formControlName="maxWidth" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MAX_HEIGHT' | translate }}</label>
                  <input class="ui-input" formControlName="maxHeight" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.FPS' | translate }}</label>
                  <input class="ui-input" formControlName="fps" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.IFRAME_INTERVAL' | translate }}</label>
                  <input class="ui-input" formControlName="iFrameInterval" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MAX_BITRATE' | translate }}</label>
                  <input class="ui-input" formControlName="maxBitrate" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.MIN_BITRATE' | translate }}</label>
                  <input class="ui-input" formControlName="minBitrate" type="number" />
                </div>

                <div class="flex-col start-start gap-10">
                  <label>{{ 'CAMERA_EDIT_CONFIGURATION.START_BITRATE' | translate }}</label>
                  <input class="ui-input" formControlName="startBitrate" type="number" />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form>

  </div>
</div> 